import React from 'react'
import ForgetPasswordForm from './ForgetPasswordForm'

const Login = () => {
    return (
        <div className='login min-h-screen 2xl:p-40 2xl:px-96 xl:p-40 flex justify-center items-center'>
            <ForgetPasswordForm/>
        </div>
    )
}

export default Login